export default __webpack_public_path__ + "static/media/gtd7.c7a8ff1b.jpg";